import React from "react";
import { Checkbox, Form, Radio, Tooltip } from "antd";
import GetWaybillNoMethod from "@/scenes/OrderManagement/components/dialogs/PrintWaybillDialog/GetWaybillNoMethod";
import { observer } from "mobx-react-lite";
import { FormInstance } from "antd";
import { PrintWaybillFormValues } from "./PrintWaybillForm";

interface WaybillNoMethodFormItemProps {
    form: FormInstance<PrintWaybillFormValues>;
}

interface WaybillNoMethodProps {
    onChange?(e: GetWaybillNoMethod): void;
    value?: GetWaybillNoMethod;

    isGenerateWaybillNoOnly: boolean;
}

const WaybillNoMethod: React.FC<WaybillNoMethodProps> = (props) => {
    const { onChange, value: getWaybillNoMethod, isGenerateWaybillNoOnly } = props;

    const disabledGenerateWaybillNoOnly = getWaybillNoMethod === GetWaybillNoMethod.OLD;
    const disabledUseOldMethodGetWaybillNo = !!isGenerateWaybillNoOnly;

    return (
        <>
            <Tooltip placement="top" title="请选择运单号获取方法" zIndex={999}>
                {/* @ts-ignore */}
                <Radio.Group onChange={onChange} value={getWaybillNoMethod}>
                    <Radio value={GetWaybillNoMethod.NEW}>获取新单号</Radio>
                    <Radio value={GetWaybillNoMethod.OLD} disabled={disabledUseOldMethodGetWaybillNo}>
                        使用旧单号
                    </Radio>
                </Radio.Group>
            </Tooltip>

            <Form.Item name="isGenerateWaybillNoOnly" noStyle valuePropName="checked">
                <Checkbox disabled={disabledGenerateWaybillNoOnly}>仅获取电子面单号不打印面单</Checkbox>
            </Form.Item>
        </>
    );
};

/**
 * 设置电子面单号获取方法
 *
 * 如果有订单已经打印过了不设置默认值让用户自己选择
 * 如果订单都没打印过，选中『获取新单号』
 */

const WaybillNoMethodFormItem: React.FC<WaybillNoMethodFormItemProps> = (props) => {
    const { form } = props;

    return (
        <Form.Item<PrintWaybillFormValues>
            noStyle
            shouldUpdate={(prev, next) => prev.isGenerateWaybillNoOnly !== next.isGenerateWaybillNoOnly}
        >
            {() => {
                const { isGenerateWaybillNoOnly } = form.getFieldsValue();

                return (
                    <Form.Item
                        label="运单号方式"
                        name="getWaybillNoMethod"
                        rules={[
                            {
                                required: true,
                                message: "请选择运单号获取方法",
                            },
                        ]}
                    >
                        <WaybillNoMethod isGenerateWaybillNoOnly={isGenerateWaybillNoOnly} />
                    </Form.Item>
                );
            }}
        </Form.Item>
    );
};

export default observer(WaybillNoMethodFormItem);
